import {buildArray, EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

import {DocumentationAttribute} from '../components/DocumentationItem/DocumentationItem';
import i18n from '../i18n/i18n';
import {getServiceBookState} from './getServiceBookState';
import {isFieldVisible} from './isFieldVisible';

type GetServiceBookAttributesParams = {
  serviceBookType: string | Nullish;
  serviceBookState: ReturnType<typeof getServiceBookState> | Nullish;
  showEmptyFields: boolean;
};

export const getServiceBookAttributes = ({
  serviceBookType,
  serviceBookState,
  showEmptyFields,
}: GetServiceBookAttributesParams) =>
  buildArray<DocumentationAttribute>()
    .when(
      isFieldVisible({
        showEmptyFields,
        isEnabledInAudit: serviceBookState?.isEnabledInAudit,
        value: serviceBookType,
      }),
      {
        label: i18n.t('type'),
        value: serviceBookType ?? EMPTY_PLACEHOLDER,
      }
    )
    .when(
      isFieldVisible({
        showEmptyFields,
        isEnabledInAudit: serviceBookState?.isEnabledInAudit,
        value: serviceBookState?.value,
      }),
      {
        label: i18n.t('status'),
        value: serviceBookState?.value ?? EMPTY_PLACEHOLDER,
      }
    );
